// This helper function returns a new object/array and recursively sanitizes it by replacing
// any nested null or undefined values with an empty string.
const sanitizeNestedValue = (value: unknown): unknown => {
  if (value === null || value === undefined) {
    return '';
  }
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeNestedValue(item));
  }
  if (typeof value === 'object') {
    return Object.keys(value).reduce<Record<string, unknown>>((acc, key) => {
      acc[key] = sanitizeNestedValue((value as Record<string, unknown>)[key]);
      return acc;
    }, {});
  }
  return value;
};
export const sanitizeAPIInput = <T>(data: T): T => {
  // Preserve the current top-level behavior by returning null/undefined inputs as-is.
  if (data === null || data === undefined) return data;
  return sanitizeNestedValue(data) as T;
};
